import { Component,NgZone } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Nav, Platform } from 'ionic-angular';
import {ContentstackService} from '../../app/contentstack';
import {DetailPage} from '../details/detail';
 

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  pages:any;
  selectedItem: any;
  constructor(public nav: Nav,public zone: NgZone,public navCtrl: NavController,private ContentstackService:ContentstackService, public navParams: NavParams) {
  	this.selectedItem = navParams.get('item') || null;
    var Query = ContentstackService.Stack.ContentType("news").Query();
    if(this.selectedItem !== null){
        Query
          .where('category',this.selectedItem.uid)
    }
       Query
       .toJSON()
       .find()
       .spread((entries, schema, count) => {
       		this.zone.run(() =>{
       			this.pages = entries;
           });
       },(err) => {
       		console.log("err",err);
       });
               
  }
  openDetailPage(uid){
    this.nav.setRoot(DetailPage,{
      item: uid
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts